export default __webpack_public_path__ + "5805b65d21390f7ce63613ffbb4776f9.png";